export default {
  cart: {
    title: 'Carro de Compra',
    list: {
      button1: ' Continuar buscando',
      button2: 'Enviar a ERP ',
      button3: 'Crear Express Quote ',
    },
    tables: {
      table1: {
        row1: 'Sin Información',
      },
      table2: {
        head: {
          header1: 'Imagen',
          header2: 'Ítem',
          header3: 'Proveedor',
          header4: 'Precio',
          header5: 'Cantidad',
          header6: 'SubTotal',
        },
        foot: {
          total: 'Total $',
        },
      },
    },
    modal: {
      title: 'Stock & Lead time Confirmation',
      form: {
        option1: {
          message: 'Confirm vendor availability',
          measures: {
            kg: 'Kg',
            mt: 'Mt',
            unit: 'Unit',
          },
        },
        option2: {
          message: 'Request to the vendor if he can deliver on following date and location',
          delivery_location: {
            singapur: 'Singapur',
            hamburgo_germany: 'Hamburgo / Germany',
            shangai: 'Shangai',
            shenzhen: 'Shenzhen',
            busan: 'Busan',
            rashid_dubai: 'Rashid / Dubai',
            ningbo_china: 'Ningbo / China',
            guangzhou: 'Guangzhou',
            rotterdam_holanda: 'Rotterdam / Holanda',
          },
        },
        option3: {
          message: 'Let the vendor propose a different date',
        },
        option4: {
          message: 'Time to respond',
        },
      },
    },
    script: {
      modalClose: {
        notify_message1: 'The data is being prepared.',
        notify_message2: 'Data submission completed.',
      },
      confirm: {
        message1: '¿Seguro que desea completar la operación?.',
        message2: 'Enviar a ERP',
        confirm_button: 'Continuar',
        cancel_button: 'Cancelar',
        then: {
          notify1: {
            title: 'Enviar a ERP',
            message: 'Estamos preparando la información a enviar.',
          },
          notify2: {
            title: 'Enviar a ERP',
            message: 'El envío de información se ha completado.',
          },
          notify3: {
            title: 'Carro de compra',
            message: 'El carro de compra se encuentra vacio.',
          },
        },
        catch: 'Data submission canceled.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/catalog/cart.js